import React, {useState, useRef, useEffect} from 'react';
import './style.scss';
import { ModalPopup } from '../ModalPopup/ModalPopup';
import Waiter from "../Waiter/Waiter";
import { WAITER_TYPES } from '../../../utils/enums.js';
import { countNonTransparentPixels } from '../../../utils/image-util.js';
import classNames from 'classnames';
import {useTranslation} from "react-i18next";

const SignModal = ({isOpen, onClose, onApply}) => {
  const {t} = useTranslation();

  const canvasRef = useRef();
  const [paint, setPaint] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const pos = useRef({x:0,y:0});

  useEffect(() => {
    const canvas = canvasRef.current;
    if(!canvas) {
      return;
    }

    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width;
    canvas.height = rect.height;

    ctx.lineCap = "round";
    ctx.strokeStyle = "black";
    ctx.lineWidth = 3;
    // eslint-disable-next-line
  }, [canvasRef.current]);

  function getPosition(event){
    pos.current = {
      x: event.clientX - canvasRef.current.offsetLeft,
      y: event.clientY - canvasRef.current.offsetTop,
    };
  }

  const startPainting = (event) => {
    setPaint(true);
    getPosition(event);
  }

  const stopPainting = (event) =>{
    setPaint(false);
    setIsDisabled(canvasRef.current ? countNonTransparentPixels(canvasRef.current) <= 300 : true);
  }

  const sketch = (e) => {
    if (!paint) return;
    const ctx = canvasRef.current.getContext('2d');
    const rect = canvasRef.current.getBoundingClientRect();
    const newX = e.clientX - rect.left;
    const newY = e.clientY - rect.top;
    const oldX = pos.current.x;
    const oldY = pos.current.y;
    const distance = Math.hypot(newX - oldX, newY - oldY);
    const steps = Math.ceil(distance / 2); // Чем меньше, тем плавнее

    for (let i = 1; i <= steps; i++) {
      const x = oldX + ((newX - oldX) * i) / steps;
      const y = oldY + ((newY - oldY) * i) / steps;
      ctx.beginPath();
      ctx.moveTo(pos.current.x, pos.current.y);
      ctx.lineTo(x, y);
      ctx.stroke();
      pos.current = { x, y };
    }
  }

  const onClear = () => {
    setIsDisabled(true);
    const canvas = canvasRef.current;
    const ctx = canvasRef.current.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }

  const onApplyClick = () => {
    const base64Sign = canvasRef.current.toDataURL("image/png");
    onApply({base64Sign});
  }

  const handleOnCancel = () => {
    onClear();
    onClose();
  }

  return (
    <ModalPopup isOpen={isOpen} containerModalClass={'signModalContainer'} content={(
      <div className={'singModal'}>
        <span className={'signTitle'}>{t("dashboard.orders.SIGNATURE")}</span>
        <canvas
          style={{ width: "100%", height: "250px" }}
          ref={canvasRef}
          onMouseLeave={stopPainting}
          onMouseDown={startPainting}
          onMouseUp={stopPainting}
          onMouseMove={sketch}
        ></canvas>
        <span onClick={onClear} className={'clear'}>{t("dashboard.orders.CLEAR_SIGNATURE")}</span>

        <div className={'buttons'}>
          <Waiter
            handleOnClick={handleOnCancel}
            useWrapClass={classNames('btn', 'denied')}
            type={WAITER_TYPES.buttonSpan}
            spanText={t("basic.CANCEL_BUTTON")}
          />
          <Waiter
            disabled={isDisabled}
            handleOnClick={onApplyClick}
            useWrapClass={classNames('btn', 'confirm')}
            type={WAITER_TYPES.buttonSpan}
            spanText={t('basic.SAVE_BUTTON')}
          />
        </div>
      </div>
    )}/>
  )
}

export default SignModal;